import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
    {
        id: "hs-04-h4v0-01",
        name: "PO 01 - H4V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 183, y: 123, width: 500, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 183, y: 463, width: 500, height: 331, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 123, width: 500, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 463, width: 500, height: 331, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-02",
        name: "PO 02 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 88, y: 114, width: 512, height: 340, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 462, width: 512, height: 340, rotation: 0, imageRotation: 0 },
            { id: "3", x: 774, y: 114, width: 512, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 462, width: 512, height: 340, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-03",
        name: "PO 03 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 333, width: 338, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 333, width: 338, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 333, width: 338, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1038, y: 333, width: 337, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },
   
    {
        id: "po-04-h4v0-04",
        name: "PO 04 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 563, width: 338, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 563, width: 338, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 563, width: 337, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1037, y: 563, width: 337, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-05",
        name: "PO 05 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 58, y: 74, width: 573, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 463, width: 573, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 744, y: 74, width: 573, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 463, width: 573, height: 380, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-04-h4v0-06",
        name: "PO 06 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 66, y: 78, width: 367, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 335, width: 367, height: 248, rotation: 0, imageRotation: 0 },
            { id: "3", x: 66, y: 591, width: 367, height: 248, rotation: 0, imageRotation: 0 },
            { id: "4", x: 752, y: 273, width: 557, height: 370, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h4v0-07",
        name: "PO 07 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 69, y: 209, width: 549, height: 500, rotation: 0, imageRotation: 0 },
            { id: "2", x: 752, y: 209, width: 557, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 752, y: 554, width: 275, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 554, width: 275, height: 154, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-08",
        name: "PO 08 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 76, y: 99, width: 346, height: 235, rotation: 0, imageRotation: 0 },
            { id: "2", x: 76, y: 342, width: 346, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 76, y: 584, width: 346, height: 234, rotation: 0, imageRotation: 0 },
            { id: "4", x: 430, y: 99, width: 868, height: 719, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h4v0-09",
        name: "PO 09 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 133, y: 170, width: 271, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 365, width: 271, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 133, y: 560, width: 271, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 170, width: 829, height: 577, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-04-h4v0-10",
        name: "PO 10 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 35, y: 35, width: 631, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 35, y: 463, width: 631, height: 420, rotation: 0, imageRotation: 0 },
            { id: "3", x: 709, y: 35, width: 631, height: 420, rotation: 0, imageRotation: 0 },
            { id: "4", x: 709, y: 463, width: 631, height: 420, rotation: 0, imageRotation: 0 }
        ],
    },

];

